import { defineColumns } from '@juvare/platform-shared/features/storage';
export const accountRegistrationEntityName = 'accountRegistration';
export const accountRegistrationMessageType = 'accountRegistrationAction';
export const accountRegistrationColumns = defineColumns({
    email: {
        type: 'string',
        index: 'unique',
    },
});
